import { useState, useEffect } from 'react';

export function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <header className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-rose-50 via-white to-amber-50/30">
      {/* Abstract Decorative Elements - Shiva-Parvati Inspired */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-10 w-64 h-64 bg-gradient-to-br from-rose-200/20 to-amber-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-gradient-to-tr from-red-200/20 to-rose-300/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/4 w-2 h-32 bg-gradient-to-b from-transparent via-rose-300/30 to-transparent rotate-45"></div>
        <div className="absolute top-1/3 right-1/4 w-2 h-40 bg-gradient-to-b from-transparent via-amber-300/30 to-transparent -rotate-45"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {/* Decorative Top Element */}
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="w-20 h-20 flex items-center justify-center">
                <i className="ri-heart-3-line text-5xl text-rose-700"></i>
              </div>
              <div className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center">
                <i className="ri-sparkling-2-fill text-xl text-amber-600"></i>
              </div>
            </div>
          </div>

          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight" style={{ fontFamily: "'Cinzel', serif" }}>
            <span className="bg-gradient-to-r from-rose-800 via-red-700 to-rose-900 bg-clip-text text-transparent">
              Clarity for
            </span>
            <br />
            <span className="bg-gradient-to-r from-amber-800 via-rose-800 to-red-900 bg-clip-text text-transparent">
              Arranged Marriage
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-700 mb-4 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: "'Lora', serif" }}>
            Development through <strong className="text-rose-800">clarity</strong>, not relationship advice
          </p>

          <p className="text-lg md:text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
            Expert guidance to help you gain <strong className="text-rose-700">clarity</strong> about your potential arranged marriage partner
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <a 
              href="#services" 
              className="group px-8 py-4 bg-gradient-to-r from-rose-800 to-red-900 text-white rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              Explore Services
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </a>
            <a 
              href="#consultation" 
              className="px-8 py-4 bg-white text-rose-800 border-2 border-rose-800 rounded-full font-semibold text-lg hover:bg-rose-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Book Consultation
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-8 text-gray-600">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-global-line text-2xl text-rose-700"></i>
              </div>
              <span className="font-medium">Worldwide Service</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-map-pin-line text-2xl text-rose-700"></i>
              </div>
              <span className="font-medium">India Focused</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-user-heart-line text-2xl text-rose-700"></i>
              </div>
              <span className="font-medium">Expert Guidance</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Decorative Wave */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
    </header>
  );
}
